import interceptor from '@/common/interceptor/interceptor';
import type { SingleShipmentDataExtended } from './types';

/** The detail fields the Sensor modal reads: the chain of custody for its events, and the sensor report's key info. */
export type SensorReportShipment = Partial<
  Pick<
    SingleShipmentDataExtended,
    | 'chain_of_custody'
    | 'reference_number'
    | 'courier'
    | 'courier_tracking_id'
    | 'from_location'
    | 'to_location'
  >
>;

interface DetailEnvelope {
  data: {
    is_success: boolean;
    data?: SensorReportShipment;
  };
}

/**
 * Fetches a shipment's detail without its sensor payload, for the Sensor modal when it opens without the drawer's
 * detail, using the share token instead of the login when given; failures reject without a toast.
 */
export const fetchShipmentReportDetail = async (
  shipmentId: string,
  shareToken?: string
): Promise<SensorReportShipment> => {
  const params = new URLSearchParams({
    home: 'false',
    include_monitor: 'false',
    sensor_payload_mode: 'none',
  });
  if (shareToken) params.set('token', shareToken);
  const path = `/shipment/${shipmentId}/?${params.toString()}`;
  const response = shareToken
    ? await interceptor.axiosWithoutHaeders('Get', path, undefined, null, true)
    : await interceptor.axiosGet('Get', path, undefined, undefined, null, true);
  const body = (response.data as DetailEnvelope).data;
  if (!body.is_success) throw new Error("Couldn't load the shipment's detail.");
  return body.data ?? {};
};
